import { Form } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import InstantSwitch from '../InstantSwitch'
import type { OptionsAPI } from '../useOptions'

const KEYS = [
  'PasswordLoginEnabled',
  'PasswordRegisterEnabled',
  'EmailVerificationEnabled',
  'RegisterEnabled',
  'TurnstileCheckEnabled',
]

const TOGGLES: Array<{ key: string; label: string; defaultChecked?: boolean }> = [
  { key: 'PasswordLoginEnabled', label: '允许密码登录', defaultChecked: true },
  { key: 'PasswordRegisterEnabled', label: '允许密码注册', defaultChecked: true },
  { key: 'EmailVerificationEnabled', label: '密码注册需邮箱验证' },
  { key: 'RegisterEnabled', label: '允许新用户注册', defaultChecked: true },
  { key: 'TurnstileCheckEnabled', label: '启用 Turnstile 校验（登录/注册）' },
]

export default function AuthRegisterSection({ options }: { options: OptionsAPI }) {
  return (
    <SettingSectionCard
      title="注册与认证"
      subtitle="控制登录、注册与 Turnstile 校验开关（Turnstile 密钥仍在系统 Tab 配置）"
      keys={KEYS}
      options={options}
    >
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          {TOGGLES.map(({ key, label, defaultChecked }) => (
            <Form.Item key={key} label={label}>
              <InstantSwitch options={options} optionKey={key} defaultChecked={defaultChecked ?? false} />
            </Form.Item>
          ))}
        </div>
      </Form>
    </SettingSectionCard>
  )
}
